// Angular modules
import { Component }             from '@angular/core';
import { FormControl }           from '@angular/forms';
import { FormGroup }             from '@angular/forms';
import { FormBuilder }           from '@angular/forms';
import { Validators }            from '@angular/forms';

// Ionic modules
import { GoogleAnalytics }       from '@ionic-native/google-analytics';
import { NavController }         from 'ionic-angular';
import { ModalController }       from 'ionic-angular';
import { MenuController }        from 'ionic-angular';

// External modules
import { FlushingCalculation }   from '../calculator-results/calculation.provider';
import { CalculatorResultsPage } from '../calculator-results/calculator-results';
import { TranslateService }      from '@ngx-translate/core';

// Helpers
import { StorageHelper }         from '../../shared/helpers/storage.helper';

@Component({
  selector    : 'page-gas-flushing',
  templateUrl : 'gas-flushing.html'
})

export class GasFlushingPage
{
  formGroup   : FormGroup           = null;
  numberRegex : string              = `^([0-9]+([,|\\.][0-9]+)?)$`;
  calculation : FlushingCalculation = new FlushingCalculation();

  constructor(public navCtrl     : NavController,
              public modalCtrl   : ModalController,
              public menuCtrl    : MenuController,
              public translate   : TranslateService,
              private builder    : FormBuilder,
              private analytics  : GoogleAnalytics)
  {
    this.getSelectedUnit();
    this.loadFormGroup();
  }

  ionViewDidLoad() { this.analytics.trackView("Flushing"); }

  toggleMenu() { this.menuCtrl.toggle(); }

  getSelectedUnit()
  {
    this.calculation.unit = StorageHelper.getUnit();
  }

  backAction() { this.navCtrl.pop({animate: false})}

  public loadFormGroup() : void
  {
    this.formGroup = this.builder.group({
      bagVolume : new FormControl({
        value    : null,
        disabled : false
      }, [Validators.required]),
      o2accepted : new FormControl({
        value    : null,
        disabled : false
      }, [Validators.required]),
      eqCapacity : new FormControl({
        value    : null,
        disabled : false
      }, [Validators.required]),
      workingHours : new FormControl({
        value    : null,
        disabled : false
      }, [Validators.required]),
      workingDays : new FormControl({
        value    : null,
        disabled : false
      }, [Validators.required]),
      workingMonths : new FormControl({
        value    : null,
        disabled : false
      }, [Validators.required])
    });
  }

  public onClickSubmit() : void
  {
    let bagVolume     : string = null;
    let o2accepted    : number = null;
    let eqCapacity    : string = null;
    let workingHours  : string = null;
    let workingDays   : string = null;
    let workingMonths : string = null;

    bagVolume     = this.formGroup.controls.bagVolume.value.replace(    ',', '.');
    o2accepted    = this.formGroup.controls.o2accepted.value;
    eqCapacity    = this.formGroup.controls.eqCapacity.value.replace(   ',', '.');
    workingHours  = this.formGroup.controls.workingHours.value.replace( ',', '.');
    workingDays   = this.formGroup.controls.workingDays.value.replace(  ',', '.');
    workingMonths = this.formGroup.controls.workingMonths.value.replace(',', '.');

    this.calculation.bagVolume     = Number(bagVolume);
    this.calculation.o2accepted    = o2accepted;
    this.calculation.eqCapacity    = Number(eqCapacity);
    this.calculation.workingHours  = Number(workingHours);
    this.calculation.workingDays   = Number(workingDays);
    this.calculation.workingMonths = Number(workingMonths);

    let profileModal = this.modalCtrl.create(CalculatorResultsPage, this.calculation);
    profileModal.present();
  }
}


// WEBPACK FOOTER //
// ./src/app/pages/gas-flushing/gas-flushing.ts